import { render, staticRenderFns } from "./NdaIcon.vue?vue&type=template&id=d4cad3a0"
import script from "./NdaIcon.vue?vue&type=script&lang=js"
export * from "./NdaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports